import { Box, Grid2, Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { LandingPageSection } from "../static-page-components/landing-page-section";
import { DesignersPersonaCards } from "./designers-persona-cards";

export const OurDesignersSection = () => (
  <LandingPageSection className="our-designers-section" sx={{ pt: { xs: 0, md: 8 }, pb: { xs: 8, md: 8 } ,mb:{xs:0,md:13.5} }}>
    <Grid2 container columns={12} spacing={"64px"}>
      <Grid2
        size={{ xs: 12, md: 6 }}
        alignContent={"center"}
      >
        <Typography variant="overline" className="text-purple">
          OUR DESIGNERS
        </Typography>
        <Typography
          variant={"display2" as any}
          component="h2"
          className="text-pink"
          sx={{ mb: { xs: "16px", md: "24px" } }}
          fontWeight={700}
        >
          MEET YOUR FUTURE DESIGNER
        </Typography>
        <Typography variant="h6" component="h3" sx={{ my: { xs: "24px", md: "24px" , color: "#111827"}}}>
          At Home Design Guild, we're here to help you easily navigate the sea of designer choices by:
        </Typography>
        <Box sx={{ borderBottom: {xs:'none',md:"1px solid #E3E3E3"}, pb:{xs:"0",md: "24px"}, mb: "24px" }}>
          {[
            "Ensuring each designer in our community is a vetted professional, each bearing the Home Design Seal of Approval",
            "Curating matches that are best suited for you and your project ",
            'Allowing you time to \"date\" a few designers before committing to \"the one\"'
          ].map((item) => (
            <Stack
              direction="row"
              alignItems={"flex-start"}
              sx={{ mb: "8px" }}
              spacing={2}
              key={item}
            >
              <CheckIcon className="text-pink" />
              <Typography variant="body1">{item}</Typography>
            </Stack>
          ))}
        </Box>
        <Typography variant="body1" className="font-size-3 contain-text" sx={{ mt: "1rem" }} lineHeight={"28px"}>
          Don't risk your project — match with a designer who meets the highest standards in the industry.
        </Typography>
      </Grid2>
      <Grid2
        size={{ xs: 12, md: 6 }}
        sx={{ overflowX: "auto", overflowY: "hidden" }}
      >
        <DesignersPersonaCards />
      </Grid2>
    </Grid2>
  </LandingPageSection>
); 